import React, { ChangeEvent, RefObject } from "react";
import { Image } from "react-bootstrap";
import { FaCamera } from "react-icons/fa";
import { useTranslation } from "react-i18next";

interface ThermogramReferenceImageProps {
    mode: string | null;

    imageUrlRef: string | null;
    onOpenLightbox?: () => void;

    handleImageButtonClick?: () => void;
    imageInputRef?: RefObject<HTMLInputElement>;
    onImageRefChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ThermogramReferenceImage = ({
    mode,
    imageUrlRef,
    onOpenLightbox,
    handleImageButtonClick,
    imageInputRef,
    onImageRefChange,
}: ThermogramReferenceImageProps) => {
    const { t } = useTranslation();
    const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });

    const isView = mode === "view";
    const fontSize = isView ? "0.84rem" : "1rem";
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="mt-2" style={{ fontWeight: 700, fontSize: fontSize }}>
                    {tt("pages.thermography.thermogramReferenceImage.title")}
                </span>

                {mode !== "view" && (
                    <button
                        type="button"
                        className="btn btn-light btn-sm m-0 p-2 border rounded-circle"
                        aria-label={tt("pages.thermography.thermogramReferenceImage.selectImageAria")}
                        onClick={handleImageButtonClick}
                        style={{ marginTop: "0px!important" }}
                    >
                        <FaCamera />
                    </button>
                )}

                <input
                    ref={imageInputRef}
                    type="file"
                    accept="image/*"
                    className="d-none"
                    onChange={onImageRefChange}
                />
            </div>

            <div className="w-100 border rounded d-flex justify-content-center align-items-center bg-light">

                {imageUrlRef ? (
                    <Image
                        src={imageUrlRef}
                        loading="lazy"
                        alt={tt("pages.thermography.thermogramReferenceImage.previewAlt")}
                        fluid
                        style={{ objectFit: "cover" }}
                        onClick={onOpenLightbox}
                    />
                ) : (
                    <span className="text-muted">{tt("pages.thermography.thermogramReferenceImage.noImage")}</span>
                )}
            </div>
        </>
    );
};

export default ThermogramReferenceImage;
